<mat-card>
    <mat-card-content>{{warning}}</mat-card-content>
</mat-card>